<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    errors: {
      required: true
    },
    form_options: {
      type: Object,
      required: false
    }
  },
  
  computed: {
    genderOptions() {
        let options = [];
        
        if ( this.form_options && this.form_options.gender ) {
            for ( let gender of this.form_options.gender ) {
                options.push({id: gender, label: gender});
            }
        }
        
        return options;
    },
    
    stateOptions() {
        let options = [];
        
        if ( this.form_options && this.form_options.states ) {
            for ( let state of this.form_options.states ) {
                options.push({id: state.slug, label: state.label});
            }
        }
        
        return options;
    }
  },
}
</script>
